import React from "react";

const HighlightCourseLayout = ({
  title,
  subtitle,
  image,
  content,
  contactSubject,
}) => {
  return (
    <div className="shadow-effect-courses-carousel">
      <div className="item-content">
        <div className="course-name">
          <h4 style={{ marginBottom: 0, marginTop: "14px" }}>{title}</h4>
        </div>
        {subtitle && (
          <p
            className="item-content-headline"
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
};

export default HighlightCourseLayout;
